<nz-spin [nzSpinning]="isLoading">
    <div class="container">
        <button style="margin: 15px" class="floatR marginB" nz-button nzType="primary" nzShape="circle"
            (click)="showAddModal()">
            <span nz-icon nzType="plus" nzTheme="outline"></span>
        </button>

        <h2>Marketing Leads</h2>

        <nz-table #basicTable [nzData]="leads" [nzBordered]="true" [nzSize]="'middle'">
            <thead>
                <tr>
                    <th>Customer Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Current Status</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let lead of leads">
                    <td>{{ lead.first_name | titlecase }} {{ lead.last_name | titlecase }}</td>
                    <td>{{ lead.email }}</td>
                    <td>{{ lead.phone }}</td>
                    <td>{{ lead.status | titlecase }}</td>
                    <td>
                        <a (click)="showResolveModal(lead)">Resolve</a> - <a (click)="seeHistory(lead)">History</a>
                    </td>
                </tr>
            </tbody>
        </nz-table>

    </div>
</nz-spin>

<nz-modal [(nzVisible)]="isModalVisible" nzTitle="Manual Review" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
    <ng-container *nzModalContent>
        <nz-form [nzLayout]="'vertical'" [formGroup]="stateForm">
            <nz-form-item>
                <nz-form-label nzRequired>Update this lead?</nz-form-label>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label>Name</nz-form-label>
                <nz-form-control>
                    <span>{{ selected?.first_name | titlecase }} {{ selected?.last_name | titlecase }}</span>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-select nzShowSearch nzPlaceHolder="Select a status" formControlName="state" style="width: 300px">
                    <nz-option *ngFor="let s of statuses" [nzLabel]="s.name" [nzValue]="s.state"></nz-option>
                </nz-select>
            </nz-form-item>
        </nz-form>
    </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="isHistoryModalVisible"
    nzTitle="{{ historyOrder?.first_name }} {{ historyOrder?.last_name }}'s History" (nzOnCancel)="closeHistoryModal()"
    (nzOnOk)="closeHistoryModal()">
    <ng-container *nzModalContent>
        <nz-table [nzData]="historyOrder.history" [nzBordered]="true" [nzSize]="'middle'">
            <thead>
                <tr>
                    <th>Date Changed</th>
                    <th>Status</th>
                    <th>Updated By</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let entry of historyOrder.history">
                    <td>{{ entry.changedDate | date: 'short' }}</td>
                    <td>{{ entry.status | titlecase }}</td>
                    <td>{{ getUserName(entry.userChanged) }}</td>
                </tr>
            </tbody>
        </nz-table>

    </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="addModal" nzTitle="Add User" nzCentered (nzOnCancel)="cancelAdd()" (nzOnOk)="confirmAdd()">
    <ng-container *nzModalContent>
        <form [formGroup]="addForm">

            <nz-form-item>
                <nz-form-label>First Name</nz-form-label>
                <input nz-input formControlName="first" />
            </nz-form-item>

            <nz-form-item>
                <nz-form-label>Last Name</nz-form-label>
                <input nz-input formControlName="last" />
            </nz-form-item>

            <nz-form-item>
                <nz-form-label>Email</nz-form-label>
                <input nz-input formControlName="email" />
            </nz-form-item>

            <nz-form-item>
                <nz-form-label>Phone Number</nz-form-label>
                <input nz-input mask="+0 (000) 000-0000" formControlName="phone" />
            </nz-form-item>

            <nz-form-item>
                <nz-select nzShowSearch nzPlaceHolder="Select a status" formControlName="status" style="width: 300px">
                    <nz-option *ngFor="let s of statuses" [nzLabel]="s.name" [nzValue]="s.state"></nz-option>
                </nz-select>
            </nz-form-item>

        </form>
    </ng-container>
</nz-modal>